import { HelpPanel, Link } from '@amzn/awsui-components-react';
import { Trans, useTranslation } from 'react-i18next';
import { externalLinks } from '../../../../data/externalLinks';
import React from 'react';

export function CoordinatorNotificationHelpPanel() {
  const { t } = useTranslation(['events']);
  return (
    <HelpPanel
      header={<h2>{t('notificationPreferences.infoHeader')}</h2>}
      footer={
        <>
          <h2>{t('notificationPreferences.infoLearnMoreTitle')}</h2>
          <Link
            href={externalLinks.events.coordinatorNotificationUserGuide}
            external
            data-aci-analytics-name="eventCreation_coordNotificationGuideLinkClicked"
            data-aci-analytics-value="Coordinator Notifications User Guide"
          >
            {t('notificationPreferences.infoUserGuideLink')}
          </Link>
        </>
      }
    >
      <p>{t('notificationPreferences.infoGeneral')}</p>
      <h3>{t('notificationPreferences.realTimeInfoHeader')}</h3>
      <Trans
        i18nKey="notificationPreferences.infoRealTime"
        t={t}
        components={{
          br: <br />,
        }}
      />
      <h3>{t('notificationPreferences.summaryInfoHeader')}</h3>
      <Trans
        i18nKey="notificationPreferences.infoSummary"
        t={t}
        components={{
          br: <br />,
          b: <b />,
          ul: <ul />,
          li: <li />,
        }}
      />
    </HelpPanel>
  );
}
